import { apiCall } from '@/api/index'
import { addQueryParamsToReqPayload } from '@/api/configure'
import { apiV1CommunitiesPath, apiV1CommunityPath } from '@/../lib/routes'

export function getCommunities({ ctxt = 'admin', fields = [], filter = {}, sort = '' } = {}) {
  const payload = {}
  addQueryParamsToReqPayload(payload, 'communities', { fields, filter, sort })

  return apiCall({
    path: apiV1CommunitiesPath(ctxt),
    payload
  })
}

export function getCommunity({ ctxt = 'admin', communityId, fields = [], filter = {}, sort = '' } = {}) {
  const payload = {}
  addQueryParamsToReqPayload(payload, 'communities', { fields, filter, sort })

  return apiCall({
    path: apiV1CommunityPath(ctxt, communityId),
    payload
  })
}

export function updateCommunity({ ctxt = 'admin', communityId, name = undefined } = {}) {
  const payload = {
    data: {
      type: 'communities',
      id: communityId,
      attributes: {
        name
      }
    }
  }

  return apiCall({
    method: 'PATCH',
    path: apiV1CommunityPath(ctxt, communityId),
    payload
  })
}

export function deleteCommunity({ ctxt = 'admin', communityId } = {}) {
  return apiCall({
    method: 'DELETE',
    path: apiV1CommunityPath(ctxt, communityId)
  })
}

export function createCommunity({ ctxt = 'admin', groupId, name } = {}) {
  const payload = {
    data: {
      type: 'communities',
      attributes: {
        name
      },
      relationships: {
        group: {
          data: {
            type: 'groups',
            id: groupId
          }
        }
      }
    }
  }

  return apiCall({
    method: 'POST',
    path: apiV1CommunitiesPath(ctxt),
    payload
  })
}
